import React from 'react';
import LegalLayout from '../components/LegalLayout';
import { legalTranslations } from '../lib/i18n/legal';

export default function TermsAr() {
  const content = legalTranslations.ar.terms;
  const ui = legalTranslations.ar.ui;

  return (
    <LegalLayout
      title={content.title}
      intro={content.intro}
      sections={content.sections}
      metaTitle={content.metaTitle}
      metaDescription={content.metaDesc}
      tocTitle={ui.toc}
      lastUpdatedText={ui.lastUpdated}
    />
  );
}